import { buildQueryString } from '../helpers/Utils';

export default class Positions {
  constructor(api) {
    this.api = api;
  }

  getLastPositions() {
    return new Promise((resolve, reject) => {
      this.api
        .fetch('/api/positions/last', {
          method: 'GET',
          credentials: 'include',
          headers: {
            Accept:
              'application/json, application/xml, text/plain, text/html, *.*',
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          resolve(res.json());
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  search(query) {
    query = query || {};
    const queryString = buildQueryString(query);

    return new Promise((resolve, reject) => {
      this.api.fetch('/api/positions/search' + queryString).then(res => {
        res.json().then(json => resolve(json.data));
      });
    });
  }
}
